export class LanguageConstants {
  static readonly HELP = $localize`:@@header-language.help:Help`;
  static readonly LANGUAGE = $localize`:@@header-language.language:Language`;
  static readonly CANCEL = $localize`:@@header-language.cancel:Cancel`;
  static readonly SELECT_LANGUAGE = $localize`:@@header-language.select-language:Select Language`;
  static readonly SELECTED_LANGUAGE_NAME = $localize`:@@header-language.english:English - United States`;
  static readonly SELECT_LANGUAGE_CODE = 'en-US'; //Need not be localized
  static readonly NEVER = $localize`:@@create-logo-content.tab-pane.never:Never`;
}
